export default __webpack_public_path__ + "static/media/about-me.a764e771.jpg";